import * as types from './mutationType'
import i18n from '@/config/i18n'

export const actions = {
  handler: () => {},
  test: () => {
    return true
  },
  setLanguage: ({ commit }: any, lang: string) => {
    commit(types.SET_LANG, lang)
    i18n.locale = lang
  },
  setLoadingState: ({ commit }: any, state: string) => {
    commit(types.ADD_LOADING_STATE, state)
  },
  unsetLoadingState: ({ commit }: any, state: string) => {
    commit(types.DELETE_LOADING_STATE, state)
  },
  setToastStack: ({ commit }: any, data: any) => {
    commit(types.ADD_TOASTS_DATA, data)
  },
  unsetToastStack: ({ commit }: any, index: number) => {
    commit(types.DELETE_TOASTS_DATA, index)
  },
  countDownToastsTime: ({ commit, state }: any, index: number) => {
    commit(types.COUNT_DOWN_TOASTS_TIME, index)
    const target = state.toastStack[index]
    setTimeout(() => {
      commit(types.DELETE_TOASTS_DATA, target.index)
    }, target.show * 1000);

  },
  setTimeZone: ({ commit }: any, timezone: string) => {
    commit(types.SET_TIME_ZONE, timezone)
  }
}
